/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvQGZ1c2UvY29tcG9uZW50cy9uYXZpZ2F0aW9uL2hvcml6b250YWwvY29sbGFwc2FibGUvY29sbGFwc2FibGUuY29tcG9uZW50LnNjc3MifQ== */"];
export { styles as styles };
